import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useNotificationWebsocket } from "@harea/notification";
import { useRuntimeEnv, useTranslationRoute } from "@harea/component";

const HareaContainer = () => {
  useNotificationWebsocket();
  const { runtimeEnv } = useRuntimeEnv();
  const location = useLocation();
  const isAuthenticated = runtimeEnv?.authenticated;
  const organisation = runtimeEnv?.organisation;
  const navigate = useNavigate();
  const tr = useTranslationRoute();

  if (
    isAuthenticated &&
    organisation !== null &&
    (location.pathname === tr("") || location.pathname === tr("admin"))
  ) {
    navigate(tr("admin/dashboard"));
  }

  return <Outlet />;
};

export default HareaContainer;
